function merciverNormalize(value) {
  return (value || '').trim().toLowerCase();
}

function merciverSlideMatchesColor(element, color) {
  const image = element.querySelector('img');
  const alt = merciverNormalize(image?.alt);
  const normalizedColor = merciverNormalize(color);

  if (!alt || !normalizedColor) return false;

  // Matches both:
  // "... - Navy Blue - Front"
  // "... - Navy Blue (model image)"
  return alt.includes(`- ${normalizedColor}`);
}

function merciverUpdateMobileGallery(card, selectedColor) {
  const gallery = card.querySelector('.merciver-mobile-gallery');
  if (!gallery) return;

  const track = gallery.querySelector('.merciver-mobile-gallery__track');
  const slides = Array.from(
    gallery.querySelectorAll('.merciver-mobile-gallery__slide')
  );

  if (!track || !slides.length) return;

  const matchingSlides = slides.filter(slide =>
    merciverSlideMatchesColor(slide, selectedColor)
  );

  // If ALT text has no matches, don't destroy the gallery.
  if (!matchingSlides.length) return;

  slides.forEach(slide => {
    const matches = matchingSlides.includes(slide);

    slide.hidden = !matches;
    slide.setAttribute('aria-hidden', matches ? 'false' : 'true');
  });

  // IMPORTANT:
  // Only move this gallery's own scroll container.
  // Do NOT use scrollIntoView().
  track.scrollLeft = 0;
}

function merciverUpdateDesktopGallery(card, selectedColor) {
  const gallery = card.querySelector('.card-gallery__desktop');
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));

  if (!slides.length) return;

  const matchingSlides = slides.filter(slide =>
    merciverSlideMatchesColor(slide, selectedColor)
  );

  if (!matchingSlides.length) return;

  slides.forEach(slide => {
    const matches = matchingSlides.includes(slide);

    slide.hidden = !matches;
    slide.setAttribute('aria-hidden', matches ? 'false' : 'true');
  });

  const firstSlide = matchingSlides[0];

  firstSlide.hidden = false;
  firstSlide.setAttribute('aria-hidden', 'false');
}

function merciverUpdateCardLinks(card, variantUrl) {
  if (!variantUrl) return;

  const links = card.querySelectorAll(
    ".product-card__link, [ref='productTitleLink'], [ref='cardGalleryLink']"
  );

  links.forEach(link => {
    if (link instanceof HTMLAnchorElement) {
      link.href = variantUrl;
    }
  });
}

/*
 * ONE global delegated listener.
 *
 * This works for:
 * - Featured Collection
 * - Catalog
 * - Infinite-scroll products
 *
 * And importantly it is registered ONCE.
 */
document.addEventListener('click', event => {
  const button = event.target.closest('.merciver-card-swatch');

  if (!button) return;

  const swatches = button.closest('.merciver-card-swatches');
  const card = button.closest('product-card');

  if (!swatches || !card) return;

  event.preventDefault();
  event.stopPropagation();

  const selectedColor = button.dataset.color;
  const variantUrl = button.dataset.variantUrl;

  if (!selectedColor) return;

  swatches
    .querySelectorAll('.merciver-card-swatch')
    .forEach(swatch => swatch.classList.remove('is-selected'));

  button.classList.add('is-selected');

  merciverUpdateCardLinks(card, variantUrl);

  merciverUpdateMobileGallery(card, selectedColor);

  // Desktop keeps its existing structure.
  merciverUpdateDesktopGallery(card, selectedColor);
});